import { ChangeDetectorRef, Component } from '@angular/core';
import { combineLatest, map, Observable, pipe, shareReplay, take } from 'rxjs';
import { ContentService } from '../../spartacus/services/content.service';
import { UserInfoService } from '../../spartacus/services/user-info.service';
import { CmsBannerComponent, OccConfig } from '@spartacus/core';
import { CmsComponentData } from '@spartacus/storefront';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { DownloadFileService } from '../../spartacus/services/download-file.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
 
@Component({
    selector: 'app-custom-quick-coding-reference',
    templateUrl: './custom-quick-coding-reference.component.html',
    styleUrls: ['./custom-quick-coding-reference.component.scss'],
    standalone: false
})
export class CustomQuickCodingReferenceComponent {
  constructor(private accessService: ContentService, public bannerComponent: CmsComponentData<CmsBannerComponent>, protected config: OccConfig, private cd: ChangeDetectorRef, private userInfoService: UserInfoService, private http: HttpClient, private downloadservice: DownloadFileService,private sanitizer: DomSanitizer) {
 
   }
  firstheadline: Observable<any> = this.bannerComponent.data$;
  mergedObject1: any = [];
  mergedObject2:any=[];
  multiplecall:boolean=false;
  ngOnInit() {

    this.firstheadline.pipe(take(1)).subscribe(res => {
     if(this.multiplecall==false){
      this.referencetabs(res);
      this.multiplecall=true;
     }
    });
       
  }
  referencetabs(res: any) {
  
   
    {
      const tilesList = res.productInfoList.split(" ");
      this.accessService.opeffeaturedResources(tilesList).pipe(shareReplay())
        .subscribe((res :any) => {
     
          this.mergedObject1=[]
        // Check if apiRes.component is an array
        if (Array.isArray(res.component)) {
          if(tilesList[0]!='SeqirusCodingBillingMobileComponent1'){
          this.mergedObject1 = res.component;
          if(this.mergedObject1.length>2)
          {
          const item = this.mergedObject1.splice(2,1);
        //  this.mergedObject1.unshift(item[0]);
          }
          this.mergedObject1.reverse();
          }else{
            this.mergedObject1 = res.component;
          }
          this.cd.detectChanges(); 
        } else if (res.component) {
          // Convert to array if it's not already
          this.mergedObject1 = [res.component];
          this.cd.detectChanges(); 
        } else {
          // Ensure it's always an array
          this.mergedObject1 = [];
        }
        this.cd.detectChanges();  // Ensure detectChanges is called correctly
      });
    }
  }
  getpdf(pdf: any): string {
    return this.config.backend?.occ?.baseUrl + pdf + "&attachment=true";
  }
  
  pdfDownload(url: string):void {
    this.downloadservice.downloadFile(url)
      .subscribe(response =>
        {
          let fileName = 'AboutusPage.pdf';
          let blob:Blob=response.body as Blob;
          let a = document.createElement('a');
          a.download = fileName;
          a.href = window.URL.createObjectURL(blob);
          a.target = '_blank';
          a.click();
        },
      );
    }
    ngOnDestroy(){
      this.mergedObject1=[]
    }
  
  }